import { derivedStream } from '@ardoq/rxbeach';
import { map } from 'rxjs/operators';
import { appModelStateEdit$ } from 'appModelStateEdit/appModelStateEdit$';
import { AppModelStateEditStreamShape } from 'appModelStateEdit/types';
import { getDefaultStylePropertyValues } from 'appModelStateEdit/propertiesEditor/componentStylePropertiesEditor/utils';
import { i18nLocale$ } from 'streams/i18nLocale$';
import type { I18nLocale } from '@ardoq/i18n';
import type { MetamodelEditorLabels } from '@ardoq/metamodel-editor';
import { getMetamodelEditorLabels } from 'locales/getMetamodelEditorLabels';

type ComponentStylePreviewBase = {
  icon: string;
  image: string;
  shape: string;
  color: string;
};

type ComponentStylePreviewState = ComponentStylePreviewBase & {
  labels: MetamodelEditorLabels;
};

const getDefaultState = (): ComponentStylePreviewBase => {
  return {
    icon: '',
    image: '',
    shape: '',
    color: '',
  };
};

const toComponentStylePreviewBase = ({
  entityIDs,
  enhancedScopeData,
}: AppModelStateEditStreamShape): ComponentStylePreviewBase => {
  if (!enhancedScopeData) {
    return getDefaultState();
  }
  const componentId = entityIDs[0];
  const component = enhancedScopeData.componentsById[componentId];
  if (!component) {
    return getDefaultState();
  }
  const defaultStylePropertyValues = getDefaultStylePropertyValues(
    componentId,
    enhancedScopeData
  );
  return {
    icon: component.icon ?? defaultStylePropertyValues.icon ?? '',
    image: component.image ?? defaultStylePropertyValues.image ?? '',
    shape: component.shape ?? defaultStylePropertyValues.shape ?? '',
    color: component.color ?? defaultStylePropertyValues.color ?? '',
  };
};

const toComponentStylePreviewState = ([appModelStateEdit, i18nLocale]: [
  AppModelStateEditStreamShape,
  I18nLocale,
]): ComponentStylePreviewState => ({
  ...toComponentStylePreviewBase(appModelStateEdit),
  labels: getMetamodelEditorLabels(i18nLocale),
});

const componentStylePreview$ = derivedStream(
  'componentStylePreview$',
  appModelStateEdit$,
  i18nLocale$
).pipe(map(toComponentStylePreviewState));

export { componentStylePreview$ };
